import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {toast} from 'react-toastify';

import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import useAppContext from 'conf/AppContext';
import GitHubForm from 'pages/protected/dashboard/github/Form';


export default function GitHubPage() {
  const appContext = useAppContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  useEffect(() => {
    const abortController = new AbortController();
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/profileWithTechStack', {
          parseJson: true,
        }, abortController);
        setData(rez?.data?.user);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
          navigate('/');
        }
        setError(err);
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();

    return () => {
      abortController.abort();
    };

  }, []);

  const saveHandler = (val) => toast.success(val?.message);

  let body = <Loading />;
  if (data) {
    body = (
      <GitHubForm onSave={saveHandler} data={data} />
    );
  } else if (error) {
    body = <KyError kyError={error} />;
  }

  return body;
}
